import React, { useEffect, useState, useCallback } from "react";
import API from "../Services/Location";
import { toast } from "react-toastify";

const LocationList = ({
    selectedLocation,
    setSelectedLocation,
    label = "Center",
    isRequired = false,
    disabled = false
}) => {
    const [location, setLocation] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedLocation(e.target.value);
    };

    const bindLocation = async (is_active, limit) => {
        try {
            const payload = {
                is_active: is_active,
                limit: limit,
            }
            // console.log("payload center.......",payload)
            const response = await API.getLocationList(payload);
            setLocation(response?.data?.data || []);
        } catch (error) {
            setError(error);

            // {"success":false,"message":"Unauthorized access"}
            console.error(error);
            console.log('error.response.status', error.response.status);
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
        }
    };

    useEffect(() => {
        const companyId = localStorage.getItem("company_id");
        if (companyId) {
            bindLocation(1, 0);
        } else {
            setError("No company ID found in localStorage.");
        }
    }, []);

    return (
        <div className="row">
            <div className="col-md-12">
                {/* <div className="form-group"> */}
                {/* <label htmlFor="ddlDesignation" className="mb-1">Center
                     <span style={{ color: "red" }}>*</span>
                     </label> */}
                <label htmlFor="ddlDesignation" className="mb-1">
                    {label}
                    {isRequired && <span style={{ color: "red" }}> *</span>}
                </label>

                <select
                    className="form-select"
                    id="ddlDesignation"
                    value={selectedLocation}
                    onChange={handleChange}
                    disabled={disabled}>

                    <option value="">Select</option>
                    {location.length > 0 ? (
                        location.map((loc) => (
                            <option key={loc.id} value={loc.id}>
                                {loc.name}
                            </option>
                        ))
                    ) : (
                        <option disabled>No center available</option>
                    )}
                </select>
                {error && <p style={{ color: "red", marginTop: "0px" }}>{error}</p>}
                {/* </div> */}
            </div>
        </div>
    );
};

export default LocationList;
